import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Field } from 'formik';
import { Link } from 'react-router-dom';
import { IFormController } from '../types';

const CheckBox = (props: IFormController) => {
  const { label, name, link } = props;
  return (
    <Grid>
      <Box>
        <Box display='flex'>
          <Box display='flex'my='auto'
            mr={1}>
            <Field type='checkbox' name={name} />
          </Box>
          {link ? 
            <Link to='/terms'>
              <Typography>{label}</Typography>
            </Link>
            : <Typography>{label}</Typography>
          }
        </Box>
      </Box>
    </Grid>
  );
};

export default CheckBox;